import WeGlide from 'client/javascript/we_glide/we_glide';
import { logError } from 'client/javascript/util/logger';
import {
  renderMultipleModules,
  renderSingleUniqueModule
} from 'client/javascript/util/geolocation_based_module_rendering';
import { TEAMS } from 'shared/rollbar/global_prefixes';
import { SHARED_MODULES } from 'shared/rollbar/shared_modules_prefixes';

const SELECTORS = {
  MEDIA_TEXT_GLIDE: '.js-geo-media-text-one-across-glide',
  MEDIA_TEXT_ITEM: '.js-geo-media-text-one-across',
  MEDIA_TEXT_ITEM_LINK: '.js-geo-media-text-one-across-link'
};
const LOGGING_CONFIG = {
  prefix: `${SHARED_MODULES}[MediaAndTextOneAcrossUI]`,
  team: TEAMS.MARKETING
};

export const setupMediaAndTextOneAcrossModule = async () => {
  try {
    await renderMultipleModules({ selector: SELECTORS.MEDIA_TEXT_ITEM });

    return [...document.querySelectorAll(SELECTORS.MEDIA_TEXT_ITEM)].reduce((glides, mediaText1AcrossNode, index) => {
      renderSingleUniqueModule({ context: mediaText1AcrossNode, selector: SELECTORS.MEDIA_TEXT_ITEM_LINK });

      if (mediaText1AcrossNode.querySelector(SELECTORS.MEDIA_TEXT_GLIDE)) {
        // We use such strange selector because each module from this list can have a slider and should pass reference to itself correctly
        const selector = `${SELECTORS.MEDIA_TEXT_ITEM}:nth-child(1n + ${index + 1}) ${SELECTORS.MEDIA_TEXT_GLIDE}`;

        glides.push(WeGlide.setup(selector));
      }
      return glides;
    }, []);
  } catch (error) {
    logError(`${LOGGING_CONFIG.prefix}[setupMediaAndTextOneAcrossModule()] failed`, error, {
      team: LOGGING_CONFIG.team
    });
  }
};
